import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'back-to-button',
  templateUrl: './back-to-button.component.html',
  styleUrls: ['./back-to-button.component.sass']
})
export class BackToButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
